/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { createContext } from 'preact'

/**
 * Preact context carrying the App instance. Components mounted inside
 * `<AppContext.Provider value={app}>` can read it via `useContext(AppContext)`
 * instead of touching the `window.App` global.
 *
 * @type {import('preact').Context<App | null>}
 */
export const AppContext = createContext(null)
